<!-- Header Section -->
<header class="header">
  <div class="logo">Kiko VPN</div>
  <nav class="navigation">
      <a href="/home">Home</a>
      <a href="/downloads">Downloads</a>
      <a href="/privacy">Privacy</a>
      <a href="/terms">Terms</a>
      <a href="/reseller">Reseller</a>
      <a href="/faq">Faq</a>
      <a href="/support">Support</a>
      <a href="/about">About Us</a>
  </nav>
</header>
  <div class="reseller-container">
    <!-- Reseller Program Offer -->
    <div class="program-offer">
      <h2>Join Our Reseller Program</h2>
      <p>Become a reseller today and start earning by offering our VPN services! Enjoy attractive commissions, flexible terms, and great support.</p>
      <button class="join-btn" (click)="joinReseller()">Join Now</button>
      <div class="adsterra-direct-link">https://www.effectiveratecpm.com/nghdw8h5?key=ad674557461a8b47e9eca4a3fde9b91e</div>
    </div>
  
    <!-- Scratch Card Pricing -->
    <div class="pricing-section">
      <h3>Pricing for Scratch Cards</h3>
      <div class="pricing-plans">
        <div class="pricing-card" *ngFor="let item of pricing">
          <h4>{{item.name}}</h4>
          <p>Price: ${{item.amount}}</p>
          <p>Get {{item.count}} scratch cards for ${{item.amount}}</p>
          <button class="purchase-btn" (click)="purchaseResellerCoupon(item)">Purchase</button>
        </div>
      </div>
    </div>

    <div data-nat='6063099'></div>

    <div class="modal-overlay" *ngIf="isModalOpen" (click)="closeModal()">
      <div class="modal-content" (click)="$event.stopPropagation()">
        <h2>Select Region and Enter Email</h2>
    
        <form id="reseller-form">
          <div class="form-group">
            <label for="email">Email:</label>
            <input type="email" id="email" [(ngModel)]="email" name="email" required />
          </div>
    
          <div class="form-group">
            <label for="region">Region:</label>
            <div class="select-wrapper">
              <select id="region" [(ngModel)]="region" name="region" required>
                <option value="" disabled>Select Region</option>
                <option *ngFor="let region of regions" [value]="region">{{ region }}</option>
              </select>
            </div>
          </div>
    
          <button class="pay-btn" (click)="createReseller()" *ngIf="isJoining">Join</button>
          <button class="pay-btn" (click)="initPayment()" *ngIf="!isJoining">Pay Now</button>
          <button type="button" (click)="closeModal()">Cancel</button>
        </form>
      </div>
    </div>

    <!-- Loader Component -->
    <div class="loader-overlay" *ngIf="isLoading">
      <div class="loader">
        <div class="spinner"></div>
      </div>
    </div>

  </div>